// src/models/egresoCabModel.js

import pb from '../lib/pocketbase';

// Obtener lista de egresos con paginación
export async function getEgresoCabs(page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoCab').getFullList({
      sort: '-created', // Ordenar por fecha de creación descendente
      $autoCancel: false,
    });
    return {
      items: response,
      totalItems: response.length,
      page: 1
    };
  } catch (error) {
    console.error('Error al obtener egresoCabs:', error);
    throw error;
  }
}

// Crear un nuevo egreso
export async function createEgresoCab(data) {
  try {
    const response = await pb.collection('egresoCab').create(data);
    return response;
  } catch (error) {
    console.error('Error al crear egresoCab:', error);
    throw error;
  }
}

// Actualizar un egreso existente
export async function updateEgresoCab(id, data) {
  try {
    const response = await pb.collection('egresoCab').update(id, data);
    return response;
  } catch (error) {
    console.error('Error al actualizar egresoCab:', error);
    throw error;
  }
}

// Eliminar un egreso
export async function deleteEgresoCab(id) {
  try {
    const response = await pb.collection('egresoCab').delete(id);
    return response;
  } catch (error) {
    console.error('Error al eliminar egresoCab:', error);
    throw error;
  }
}

// Obtener un egreso por ID
export async function getEgresoCabById(id) {
  try {
    const response = await pb.collection('egresoCab').getOne(id);
    return response;
  } catch (error) {
    console.error('Error al obtener egresoCab por ID:', error);
    throw error;
  }
}


// ==================== ESCOLTA-RELATED METHODS ====================

// Obtener escoltas asociadas a un egreso
export async function getEgresoEscoltas(egresoCabId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoEscolta').getList(page, perPage, {
      filter: `egresoCab = "${egresoCabId}"`,
      $autoCancel: false,
      expand: "escolta",
    });
    return {
      items: response.items,
      totalItems: response.totalItems,
      page: response.currentPage,
    };
  } catch (error) {
    console.error("Error fetching egresoEscolta:", error);
    throw new Error("Error al obtener los detalles de egreso");
  }
}

// Agregar escoltas a un egreso
export async function addEscoltasToEgreso(egresoId, escoltaIds) {
  try {
    const promises = escoltaIds.map(escoltaId =>
      pb.collection('egresoEscolta').create(
        {
          egresoCab: egresoId, // Link to the egresoCab
          escolta: escoltaId,  // Link to the escolta
        },
        { $autoCancel: false } // Disable auto-cancellation for this request
      )
    );
    await Promise.all(promises); // Create all escoltas in parallel
    return { success: true };
  } catch (error) {
    console.error('Error al agregar escoltas a egreso:', error);
    throw error;
  }
}

// Eliminar escoltas de un egreso
export async function deleteEscoltasFromEgreso(egresoId) {
  try {
    const existingEscoltas = await pb.collection('egresoEscolta').getFullList({
      filter: `egresoCab = "${egresoId}"`, // Filter by egresoCab ID
      $autoCancel: false,
    });
    for (const escolta of existingEscoltas) {
      await pb.collection('egresoEscolta').delete(escolta.id); // Delete each escolta
    }
    return { success: true };
  } catch (error) {
    console.error('Error al eliminar escoltas de egreso:', error);
    throw error;
  }
}


// Obtener escoltas asociadas a un egreso
export async function getEgresoCorredores(egresoCabId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoCorredor').getList(page, perPage, {
      filter: `egresoCab = "${egresoCabId}"`,
      $autoCancel: false,
      expand: "corredor",
    });
    return {
      items: response.items,
      totalItems: response.totalItems,
      page: response.currentPage,
    };
  } catch (error) {
    console.error("Error fetching egresoEscolta:", error);
    throw new Error("Error al obtener los detalles de egreso");
  }
}

// Obtener pickers asociados a un egreso
export async function getEgresoPickers(egresoCabId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoPicker').getList(page, perPage, {
      filter: `egresoCab = "${egresoCabId}"`,
      $autoCancel: false,
      expand: "picker",
    });
    return {
      items: response.items,
      totalItems: response.totalItems,
      page: response.currentPage,
    };
  } catch (error) {
    console.error("Error fetching egresoPicker:", error);
    throw new Error("Error al obtener los detalles de egreso");
  }
}

